// Origin.saveProfileSetting
Origin.setProfileSetting = function(module, key, value, sync) {
	// Sync is either a callback function, undefined (async) or true (sync)
	if ( arguments.length == 2 ) {
		// We have no group parameter
		value	= key;
		key		= module;
		module	= '';
	}
	if ( typeof value != 'string' ) {
		value = JSON.stringify( value );
	}
	var ret = null;
	Origin.ajax({
		ajax: {
			async: ( $.isFunction(sync) || !( sync === true ) )
		},
		url: '/DirectoriesProfile/set',
		data: {
			module: module,
			key: key,
			value: value
		},
		success: function(data) {
			if ( $.isFunction(sync) ) {
				sync.call(document, data, { module: module, key: key, value: value });
			}
			// Preference saved
			ret = true;
		}
	});
	return ret;
};

// Note that this is a synchronous request, to make it async, implement a callback for the third argument
Origin.getProfileSetting = function(module, key, defaultValue, callback) {
	var setting = arguments.length > 2 ? defaultValue : null;
	var async = false;
	var callback = null;
	if ( $.isFunction( defaultValue ) ) {
		async = true;
		callback = defaultValue;
	}
	Origin.ajax({
		ajax: {
			async: async
		},
		url: '/DirectoriesProfile/Get',
		data: {
			module: module,
			key: key
		},
		error: function(error) {
			log('Error retrieving preference: module[' + module + '] key[' + key + ']');
		},
		success: function(data) {
			if ( data == '' ) {
				data = defaultValue;
			}
			if ( callback == null ) {
				setting = data;
			} else {
				callback.call({}, data);
			}
		}
	});
	log('getProfileSetting: async[' + async + '] module[' + module + '] key[' + key + '] DATA[' + setting + ']');
	if ( callback == null ) {
		return setting;
	}
};

// This will JSON decode the profile setting as it comes back if it's a string
Origin.getProfileSettingJson = function(module, key, defaultValue, callback) {
	var _callback = null;
	if ( $.isFunction(defaultValue) ) {
		defaultValue = null;
		callback = defaultValue;
	}
	if ( $.isFunction(callback) ) {
		_callback = function(data) {
			if ( typeof data == 'string' ) {
				data = JSON.parse(data);
			}
			callback.call({}, data );
		};
	}
	var ret = Origin.getProfileSetting(module, key, defaultValue, _callback);
	if ( _callback == null ) {
		if ( typeof ret == 'string' ) {
			try {
				ret = JSON.parse(ret);
			} catch(e) {
				log('Origin.getProfileSettingJson: JSON Parse Error [' + ret + ']');
			}
		}
		return ret;
	}
};